export default "__VITE_ASSET__c217ecbe__"